// extracted by mini-css-extract-plugin
export var attribution = "_85-4";
export var authorName = "_85-5";
export var quote = "_85-3";
export var testimonial = "_85-2";
export var trustedBy = "_85-0";
export var trustedByLabel = "_85-1";